var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.26775 17H2.05347V6.28572H5.26775V17ZM17.0535 17H13.8392V11.2764C13.8392 9.785 13.3078 9.0425 12.2545 9.0425C11.4199 9.0425 10.8906 9.45822 10.6249 10.2907V17H7.41061C7.41061 17 7.45347 7.35715 7.41061 6.28572H9.94775L10.1438 8.42857H10.2103C10.8692 7.35715 11.9224 6.63072 13.3667 6.63072C14.4649 6.63072 15.3531 6.93607 16.0313 7.70322C16.7138 8.47143 17.0535 9.50214 17.0535 10.9496V17Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66071 5.21429C4.5779 5.21429 5.32143 4.49474 5.32143 3.60714C5.32143 2.71954 4.5779 2 3.66071 2C2.74353 2 2 2.71954 2 3.60714C2 4.49474 2.74353 5.21429 3.66071 5.21429Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.c4d0e59fd6a3698b3f6d886cd0ad04c6.svg";
export { ForwardRef as ReactComponent };